// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2mECw","content":"LoadingAlert_content__V7iXG"};